import type { Session } from '@openx/types/session';
import type { UseSession } from '@openx/utils/permission/context/PermissionHookTypes';
import { useAuth } from '../../../components/AuthContext/context';

export const useExchangeSession: UseSession = () => {
  const { loading, session } = useAuth();

  return {
    isLoading: loading,
    // Callers must check `isLoading` before relying on `session` — it's only
    // guaranteed once auth finishes, unlike the DSP/pub react-query session.
    session: session?.exchange_session as Session,
  };
};
